<div class="card w-100">
  <div class="container card-header bg-white">
    <div class="row">
      <div class="col pe-0 my-auto">
        <h6 class="m-1">Spotlight News</h6>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div class="list-group border-0">
      <a *ngFor="let article of articles" routerLink="/article/{{article.id}}/{{encodeURIComponent(article.title.slice(0,55))}}"
        class="list-group-item list-group-item-action border-0 rounded-0"
        aria-current="true">
        <div class="d-flex">
          <div class="p-1 mt-auto mb-0 small z-1 flex-grow-1">
            <h5 class="line-clamp-2 mb-3 article-title">{{article.title}}</h5>
            <p class="m-0 text-muted line-clamp-1">
              {{article.author?.full_name}} <span *ngIf="article.read_time">• {{article.read_time}} min read</span>
            </p>
          </div>
          <div class="my-auto" style="width: 75px !important;height:75px !important;">
            <img
              [appImagePlaceholder]="getArticleImage(article)" [pclass]="'news-picture'"
              class="border rounded news-picture"
              draggable="false" />
          </div>
        </div>
      </a>
    </div>
  </div>
</div>
